//we rely on the browser's autoscroll behavior for jumping to headings in the
//table of contents and in google sitelinks. Browser autoscroll behavior is
//when the browser jumps to hashed IDs in the URL.

// The problem is that this "jump" behavior doesn't take into account the size
//of the screen displaced by our fixed navigational header. To solve this, we
//added an offset for scroll behavior
export const fixHeaderScrollOffset = () => {
  const navHeader = document.querySelector("header");
  if (navHeader) {
    document.documentElement.style.setProperty("--nav-header-height", `${navHeader.offsetHeight}px`);
  }
};
